<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.query.machineId === undefined && !openPreview"
      :hideFilter="$route.query[pk + 'filter'] === undefined" :hideOverlayRoute="$route.params.machineId == undefined">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <FilterContent :key="$route.params.filterId" :pk="pk" :hideOwnership="hideOwnershipFilters"
              :hideProduct="hideProductFilters" :hideMachineTypeFilter="hideMachineTypeFilter"
              :hideSupplierFilter="hideSupplierFilter" />
          </template>
          <template v-slot:sorting-content>
            <SortingContent :pk="pk" :sortablefields="sortablefields" :defaultsort="defaultsort">
            </SortingContent>
          </template>
        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :pk="pk" :lockedFilters="lockedFilters" ref="ListPane" :allowSelectAll="allowSelectAll"
          :compact="$route.query.machineId !== undefined || openPreview" :itemDeleteFunc="itemDeleteFunc"
          :groupByUnit="groupByUnit">
        </ListPane>
      </template>

      <template v-slot:preview>
        <slot name="preview" :customerId="customerId">
          <PreviewPane :id="$route.query.machineId" :customerId="customerId" :showToolbar="true"
            @Update="item => handlechanged(item)">
          </PreviewPane>
        </slot>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import FilterContent from "@/components/Sections/Panes/MachineListFilterContent.vue";
import ListPane from "@/components/Sections/Panes/MachineListPane3.vue";
import SortingContent from "@/components/Sections/Panes/SortingContent.vue";
import PreviewPane from "@/components/Sections/Panes/PreviewMachine.vue";
import Layout from "@/views/layouts/PreviewableList.vue";

export default {
  name: "AdminMachineList",
  props: {
    pk: {
      type: String,
      default: "ML-",
    },
    hideProductFilters: Boolean,      //hides product section
    hideSupplierFilter: Boolean,      //-- hides supplier filter
    hideMachineTypeFilter: Boolean,   //-- hides machine type filter
    hideOwnershipFilters: Boolean,    //hides customer section
    lockedFilters: Object,
    allowSelectAll: Boolean,
    openPreview: Boolean,
    itemDeleteFunc: Function,
    groupByUnit: Boolean
  },
  components: {
    FilterPane,
    FilterContent,
    ListPane,
    PreviewPane,
    Layout,
    SortingContent,
  },

  data() {
    return {
      sortablefields: [
        { Field: "Id", displayString: this.$t("servicesystem.common_objects.job.created") },
        { Field: "Qrcode", displayString: this.$t("servicesystem.common_objects.machine.qr_code") },
        { Field: "SerialNumber", displayString: this.$t("servicesystem.common_objects.machine.serial_number") },
        { Field: "MachineModel.Name", displayString: this.$t("servicesystem.common_objects.model.machine_model") },
        { Field: "MachineModel.MachineType.Name", displayString: this.$t("servicesystem.common_objects.machine_type.machine_type") },
        { Field: "SupplierId", displayString: this.$t("servicesystem.common_objects.supplier.supplier") },
        { Field: "CustomerId", displayString: this.$t("servicesystem.common_objects.customer.customer") },
      ],

      defaultsort: [
        { Field: "Id", Direction: 1 },
      ],
    };
  },

  mounted() { },

  methods: {
    handleadded(item) {
      this.$refs.ListPane.handleadded(item);
    },
    handlechanged(item) {
      this.$refs.ListPane.handlechanged(item);
    },
  },

  computed: {
    customerId() {
      return this.lockedFilters?.CustomerId ?? this.$route.query?.['filter-customer'] ?? undefined
    },
  },

  watch: {},
};
</script>